/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseCreateMstUserResponse
 */
export interface ResponseCreateMstUserResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ResponseCreateMstUserResponse
     */
    approval?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseCreateMstUserResponse
     */
    baseFlg?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponseCreateMstUserResponse
     */
    baseId?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseCreateMstUserResponse
     */
    category?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseCreateMstUserResponse
     */
    chatworkRoomId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseCreateMstUserResponse
     */
    commitment?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponseCreateMstUserResponse
     */
    createdAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseCreateMstUserResponse
     */
    deposit?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponseCreateMstUserResponse
     */
    driverName?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseCreateMstUserResponse
     */
    firstName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseCreateMstUserResponse
     */
    flg?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponseCreateMstUserResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseCreateMstUserResponse
     */
    introducer?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseCreateMstUserResponse
     */
    isInitialPassword?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseCreateMstUserResponse
     */
    isLocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseCreateMstUserResponse
     */
    isSuperAdmin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseCreateMstUserResponse
     */
    largeProduct?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponseCreateMstUserResponse
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseCreateMstUserResponse
     */
    lineId?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseCreateMstUserResponse
     */
    lineName?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseCreateMstUserResponse
     */
    loginRetriedCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseCreateMstUserResponse
     */
    mail?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseCreateMstUserResponse
     */
    monthlyCharge?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseCreateMstUserResponse
     */
    noSticker?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponseCreateMstUserResponse
     */
    password?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseCreateMstUserResponse
     */
    permissionId?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseCreateMstUserResponse
     */
    shippingNum?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseCreateMstUserResponse
     */
    shopName?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseCreateMstUserResponse
     */
    tenantId?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseCreateMstUserResponse
     */
    updatedAt?: string;
}

/**
 * Check if a given object implements the ResponseCreateMstUserResponse interface.
 */
export function instanceOfResponseCreateMstUserResponse(value: object): value is ResponseCreateMstUserResponse {
    return true;
}

export function ResponseCreateMstUserResponseFromJSON(json: any): ResponseCreateMstUserResponse {
    return ResponseCreateMstUserResponseFromJSONTyped(json, false);
}

export function ResponseCreateMstUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseCreateMstUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'approval': json['approval'] == null ? undefined : json['approval'],
        'baseFlg': json['base_flg'] == null ? undefined : json['base_flg'],
        'baseId': json['base_id'] == null ? undefined : json['base_id'],
        'category': json['category'] == null ? undefined : json['category'],
        'chatworkRoomId': json['chatwork_room_id'] == null ? undefined : json['chatwork_room_id'],
        'commitment': json['commitment'] == null ? undefined : json['commitment'],
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'deposit': json['deposit'] == null ? undefined : json['deposit'],
        'driverName': json['driver_name'] == null ? undefined : json['driver_name'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'flg': json['flg'] == null ? undefined : json['flg'],
        'id': json['id'] == null ? undefined : json['id'],
        'introducer': json['introducer'] == null ? undefined : json['introducer'],
        'isInitialPassword': json['is_initial_password'] == null ? undefined : json['is_initial_password'],
        'isLocked': json['is_locked'] == null ? undefined : json['is_locked'],
        'isSuperAdmin': json['is_super_admin'] == null ? undefined : json['is_super_admin'],
        'largeProduct': json['large_product'] == null ? undefined : json['large_product'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'lineId': json['line_id'] == null ? undefined : json['line_id'],
        'lineName': json['line_name'] == null ? undefined : json['line_name'],
        'loginRetriedCount': json['login_retried_count'] == null ? undefined : json['login_retried_count'],
        'mail': json['mail'] == null ? undefined : json['mail'],
        'monthlyCharge': json['monthly_charge'] == null ? undefined : json['monthly_charge'],
        'noSticker': json['no_sticker'] == null ? undefined : json['no_sticker'],
        'password': json['password'] == null ? undefined : json['password'],
        'permissionId': json['permission_id'] == null ? undefined : json['permission_id'],
        'shippingNum': json['shipping_num'] == null ? undefined : json['shipping_num'],
        'shopName': json['shop_name'] == null ? undefined : json['shop_name'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'updatedAt': json['updated_at'] == null ? undefined : json['updated_at'],
    };
}

export function ResponseCreateMstUserResponseToJSON(json: any): ResponseCreateMstUserResponse {
    return ResponseCreateMstUserResponseToJSONTyped(json, false);
}

export function ResponseCreateMstUserResponseToJSONTyped(value?: ResponseCreateMstUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'approval': value['approval'],
        'base_flg': value['baseFlg'],
        'base_id': value['baseId'],
        'category': value['category'],
        'chatwork_room_id': value['chatworkRoomId'],
        'commitment': value['commitment'],
        'created_at': value['createdAt'],
        'deposit': value['deposit'],
        'driver_name': value['driverName'],
        'first_name': value['firstName'],
        'flg': value['flg'],
        'id': value['id'],
        'introducer': value['introducer'],
        'is_initial_password': value['isInitialPassword'],
        'is_locked': value['isLocked'],
        'is_super_admin': value['isSuperAdmin'],
        'large_product': value['largeProduct'],
        'last_name': value['lastName'],
        'line_id': value['lineId'],
        'line_name': value['lineName'],
        'login_retried_count': value['loginRetriedCount'],
        'mail': value['mail'],
        'monthly_charge': value['monthlyCharge'],
        'no_sticker': value['noSticker'],
        'password': value['password'],
        'permission_id': value['permissionId'],
        'shipping_num': value['shippingNum'],
        'shop_name': value['shopName'],
        'tenant_id': value['tenantId'],
        'updated_at': value['updatedAt'],
    };
}

